import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Login } from "./containers/login/Login";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Article from "./containers/search/Article";
import { ArticlesManager } from "./containers/articlesManager";
import { Dashboard } from "./containers/dashboard";
import { Sources } from "./containers/sources/Sources";
import Pricing from "./containers/pricing";
import PopularPrice from "./containers/pricing/PopularPrice";
import EnterprisePrice from "./containers/pricing/EnterprisePrice";

export default function Routes() {
  return (
    <Switch>
      <UnauthenticatedRoute exact path="/login">
        <Login />
      </UnauthenticatedRoute>
      <AuthenticatedRoute exact path="/articles">
        <ArticlesManager />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/dashboard">
        <Route component={Dashboard} />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/search">
        <Route component={Article} />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/sources">
        <Sources />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/pricing">
        <Pricing />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/pricing-popular">
        <PopularPrice />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/pricing-enterprise">
        <EnterprisePrice />
      </AuthenticatedRoute>
      <Redirect from="*" to="/articles" />
    </Switch>
  );
}
